import type { PropsWithChildren } from 'react';
import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import type { SpaceProps } from 'styled-system';
import { space } from 'styled-system';

import BaseCheckbox from './Checkbox';
import { Flex } from './Flex';
import SelectCard from './SelectCard';

interface ProductCardProps extends PropsWithChildren {
  value: string;
  isSelected: boolean;
  onSelectProduct: (value: string, checked: boolean) => void;
  ariaLabelledBy?: string;
}

const StyledCardContainer = styled(SelectCard)`
  &:focus-within input[type='checkbox']:focus + svg {
    outline: none;
    border: none;
  }
`;

const Checkbox = styled(BaseCheckbox)<SpaceProps>`
  ${space};
`;

const SelectProductCard = ({
  children,
  value,
  isSelected,
  onSelectProduct,
  ariaLabelledBy,
}: ProductCardProps) => {
  const handleSelectionChange = useCallback(() => {
    onSelectProduct(value, !isSelected);
  }, [value, isSelected, onSelectProduct]);

  return (
    <StyledCardContainer
      display="flex"
      alignItems="center"
      selected={isSelected}
      onClick={handleSelectionChange}
      data-testid="select-product-card"
    >
      <Flex alignItems="center">
        <Checkbox
          p="sp_4"
          ml="sp_0"
          value={value}
          checked={isSelected}
          onChange={handleSelectionChange}
          ariaLabelledBy={ariaLabelledBy}
        />
      </Flex>
      {children}
    </StyledCardContainer>
  );
};

export default SelectProductCard;
